<template lang="pug">
.hero(:style="{ backgroundImage: `url(${imageSrc})` }")
  img.logo(v-if="logo" src='@/assets/theindex-logo-white.svg' :alt="__('The Index')")
  h1.headline(v-else v-html="headline" v-translate)
  .subtitle(v-if="subtitle" v-html="subtitle" v-translate)
</template>

<script setup lang="ts">
import { getCloudinaryUrl } from 'sisu/js/helpers'
import { computed } from 'vue'
import { useMQ } from 'sisu/js/mq'

const mq = useMQ()

const props = withDefaults(defineProps<{
  image: string,
  headline?: string,
  subtitle?: string,
  logo?: boolean,
}>(), {
  headline : undefined,
  subtitle : undefined,
  logo     : false,
})

const imageSrc = computed<string | undefined>(() => getCloudinaryUrl(props.image, mq.value === 'mobile' ? 768 : undefined))
</script>

<style lang="scss" scoped>
  .hero {
    position: relative;
    padding: 50px 24px;
    background-size: cover;
    background-position: top center;
    text-align: center;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1960px;
    margin: 0 auto $space-l auto;

    @include all-desktop() {
      padding: 150px 24px;
    }
  }

  .headline, .title {
    margin-bottom: $space-s;
    text-transform: uppercase;
    max-width: 768px;
    line-height: 1;
  }

  .headline {
    font-size: 72px;

    @include mobile() {
      font-size: 48px;
    }
  }

  .subtitle {
    font-size: $size-s;
    max-width: 500px;
  }

  .logo {
    width: 100%;
    max-width: 300px;
    margin-bottom: $space-s;
  }
</style>
